import * as fromMessageActions from '../actions/message.actions';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AuthService} from '../../services/api/auth.service';
import {Action} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {Observable} from 'rxjs';
import {MessageRestService} from '../../services/api/message/message-rest.service';

@Injectable()
export class MessageEffects {
    private actions$ = inject(Actions);
    private authService = inject(AuthService);
    private messagesRestService = inject(MessageRestService);


    loadMessages$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType<fromMessageActions.LoadMessagesAction>(fromMessageActions.MessageActionTypes.LOAD_MESSAGES))
            .pipe(map(action => action.payload), switchMap((rq) =>
                    this.messagesRestService.getMessages(rq).pipe(
                        map(data => new fromMessageActions.LoadMessagesCompleteAction(data.returnObject)),
                        catchError((error) => of(new fromMessageActions.ErrorAction(error)))
                    )
                )
            )
    );

    loadMessage$: Observable<Action> = createEffect(() =>
        this.actions$
            .pipe(ofType<fromMessageActions.LoadMessageAction>(fromMessageActions.MessageActionTypes.LOAD_MESSAGE))
            .pipe(map(action => action), switchMap((rq) =>
                this.messagesRestService.loadMessage(rq).pipe(
                    map(data => new fromMessageActions.LoadMessageCompleteAction(data.returnObject)),
                    catchError((error) => of(new fromMessageActions.ErrorAction(error)))
                )
            )
        )
    );

}
